import { render, staticRenderFns } from "./Redispensar.vue?vue&type=template&id=05621760&scoped=true"
import script from "./Redispensar.vue?vue&type=script&lang=js"
export * from "./Redispensar.vue?vue&type=script&lang=js"
import style0 from "./Redispensar.vue?vue&type=style&index=0&id=05621760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05621760",
  null
  
)

export default component.exports